package it.neckar.lizergy.model.location

import it.neckar.open.unit.si.m
import it.neckar.open.unit.si.s
import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
sealed interface RouteInformationResponse : RestResponse<RouteInformation> {

  @Serializable
  @SerialName("good")
  data class Good(override val data: RouteInformation) : RouteInformationResponse, RestResponse.GoodResponse<RouteInformation>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : RouteInformationResponse, RestResponse.BadResponse<RouteInformation>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: RouteInformation): RouteInformationResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): RouteInformationResponse = Failed
  }
}

@Serializable
data class RouteInformation(
  /**
   * The Duration in Seconds
   */
  val duration: @s Double,

  /**
   * the distance between the
   * two Coords in meters
   */
  val distance: @m Double,
)
